module.exports = __webpack_public_path__ + "img/yaoqingz.0554088c.png";